/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import PeopleRoundedIcon from '@mui/icons-material/PeopleRounded';
import { Box, Chip, Stack,  Typography } from '@mui/material';

import { CommonTable } from '../../common-components/CommonTable';
import { useUsersList } from './hooks/useUsersList';
import type { IUser } from '../../layouts/AdminLayout/slice/types';
import { useUsersTableHeader } from './hooks/useUsersTableHeader';

function useDebouncedValue<T>(value: T, delayMs: number) {
  const [debounced, setDebounced] = React.useState(value);

  React.useEffect(() => {
    const t = window.setTimeout(() => setDebounced(value), delayMs);
    return () => window.clearTimeout(t);
  }, [delayMs, value]);

  return debounced;
}

export default function Users() {

  const [query, setQuery] = React.useState('');
  const debouncedQuery = useDebouncedValue(query, 350);
  const columns = useUsersTableHeader();
  const { users, total, isLoading, error, pageIndex, setPageIndex, rowsPerPage, setRowsPerPage, currentProduct } = useUsersList({
    query: debouncedQuery,
  });



  return (
    <Box sx={{ width: '100%', overflowY: 'auto', height: '100dvh ', px: { xs: 2, md: 3 }, py: { xs: 2, md: 3 }}}>
      <Box sx={{ maxWidth: 1280, mx: 'auto', width: '100%' }}>
        <Stack direction={{ xs: 'column', md: 'row' }} sx={{height: '100px' }} alignItems={{ xs: 'flex-start', md: 'center' }} justifyContent="space-between" spacing={2}>
          <Box sx={{ minWidth: 0}}>
            <Typography variant="h4" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <PeopleRoundedIcon color="primary" />
              Users
            </Typography>
            <Stack direction="row" spacing={1} sx={{ mt: 1, flexWrap: 'wrap' }}>
              <Chip size="small" label={currentProduct ?? '—'} />
              <Chip size="small" variant="outlined" label={`${total || users.length} total`} />
            </Stack>
          </Box>

          {/* <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap" sx={{ width: { xs: '100%', md: 'auto' } }}>
            <TextField
              size="small"
              placeholder="Search by name or email"
              value={query}
              onChange={(e) => {
                setQuery(e.target.value);
                setPageIndex(0);
              }}
              sx={{ width: { xs: '100%', sm: 320 } }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchRoundedIcon fontSize="small" />
                  </InputAdornment>
                ),
              }}
            />
            <IconButton onClick={reload} disabled={isLoading} aria-label="Refresh users">
              <RefreshRoundedIcon />
            </IconButton>
          </Stack> */}
        </Stack>

      
          <Box sx={{ height: 'calc(100dvh - 200px)', backgroundColor:'transparent!important' }}>
            <CommonTable<IUser>
              columns={columns}
              rows={users}
              getRowId={(u) => u._id}
              isLoading={isLoading}
              error={error}
              emptyLabel="No users found for this product."
              pagination={{
                page: pageIndex,
                rowsPerPage,
                total: total || users.length,
                onPageChange: (next) => setPageIndex(next),
                onRowsPerPageChange: (next) => {
                  setRowsPerPage(next);
                  setPageIndex(0);
                },
              }}
            />
            </Box>
      </Box>
    </Box>
  );
}
